import {WuButton} from '@/components/button'

export const LogoutMenuItem: React.FC<{
  onLogout?: () => void
  DataCenter?: React.ReactElement
}> = ({onLogout, DataCenter}) => (
  <section className="flex justify-between px-4 py-4 text-white bg-gray-lead">
    <div className="flex-1 flex items-start">{DataCenter}</div>
    <WuButton
      variant="outline"
      size="sm"
      Icon={<span className="wm-logout"></span>}
      className="text-white bg-transparent ring-white hover:bg-gray-10 hover:text-gray-lead hover:ring-gray-lead"
      onClick={onLogout}
      aria-label="logout"
    >
      LOGOUT
    </WuButton>
  </section>
)
